var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image",attrs:{"srcset":(_vm.imageSmallUrl + " 640w, " + _vm.imageMediumUrl + " 800w, " + _vm.imageLargeUrl + " 1025w"),"src":_vm.imageLargeUrl,"alt":_vm.imageAltText,"data-test":"gc__image"}})}
var staticRenderFns = []

export { render, staticRenderFns }